import sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import auth from 'store/app/auth/action';

const mapStateToProps = state => {
  const fromAuth = state.auth.employee?.user?.companies || [];
  const fromReducer = Object.values(state.companies || {});
  const companies = (fromAuth.length > 0 ? fromAuth : fromReducer).filter(c => c?.name);

  return {
    companyId: state.auth.company_id,
    companies: sortBy(companies, 'name'),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    auth: bindActionCreators(auth, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
